import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";
import { StoreInterface } from "../storeType";

const selectDomain = (state: StoreInterface) => state.drawerState || initialState;

export const drawerOpenSelector = createSelector(
  selectDomain,
  (state) => state.drawerOpen
);
